import { render, staticRenderFns } from "./rewardValidCustomer.vue?vue&type=template&id=27c05b4d"
import script from "./rewardValidCustomer.vue?vue&type=script&lang=js"
export * from "./rewardValidCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports